import React, { useCallback, useState } from 'react';
import clsx from 'clsx';
import Skeleton from '@mui/material/Skeleton';
import Box from '@mui/material/Box';

type ImageProps = {
  src: string;
  alt?: string;
  imgclass?: any[];
};

const Image = ({ src, alt = 'custom-image', imgclass = [] }: ImageProps) => {
  const [loaded, setLoaded] = useState(false);

  const completeLoading = useCallback(() => {
    setLoaded(true);
  }, []);

  return (
    <React.Fragment>
      {!loaded && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Skeleton variant="rectangular" width={100} height={100} />
        </Box>
      )}
      <img
        src={src}
        alt={alt}
        onLoad={completeLoading}
        className={clsx(...imgclass)}
      />
    </React.Fragment>
  );
};

export default Image;
